import React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

interface MenuRowProps {
    icon: React.ReactNode;
    label: React.ReactNode;
    onClick?: () => void;
    danger?: boolean;
    isLast?: boolean;
    testId?: string;
}

export const MenuRow: React.FC<MenuRowProps> = ({
    icon,
    label,
    onClick,
    danger,
    isLast,
    testId,
}) => (
    <Box
        onClick={onClick}
        data-cy={testId}
        sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 14px",
            cursor: "pointer",
            borderBottom: isLast ? "none" : "1px solid #f2f2f4",
            color: danger ? "red" : "#1c1c1e",
            "&:hover": {
                backgroundColor: danger ? "rgba(255, 0, 0, 0.06)" : "#f7f7f8",
            },
            "& svg": {
                fontSize: "18px",
                color: danger ? "red" : "#86868b",
            },
        }}
    >
        {icon}
        <Typography
            sx={{
                fontSize: "13px",
                fontWeight: 600,
                color: "inherit",
                fontFamily: '"Nunito", sans-serif',
                lineHeight: 1.4,
            }}
        >
            {label}
        </Typography>
    </Box>
);

export const popoverMenuPaperSx = {
    mt: "8px",
    background: "#ffffff",
    border: "1px solid #e5e5ea",
    borderRadius: "8px",
    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
    minWidth: 180,
    overflow: "hidden",
};
